import { render, staticRenderFns } from "./deposit-qa.vue?vue&type=template&id=59bf7876&scoped=true"
import script from "./deposit-qa.vue?vue&type=script&lang=js"
export * from "./deposit-qa.vue?vue&type=script&lang=js"
import style0 from "./deposit-qa.vue?vue&type=style&index=0&id=59bf7876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf7876",
  null
  
)

export default component.exports